var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightMost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 442,
    viewBox: "0 0 471 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.396 61.4492C413.54 82.2332 432.658 107.627 445.48 135.916C458.3 164.205 464.532 194.742 463.764 225.479C462.996 256.216 455.244 286.455 441.022 314.168C426.798 341.881 406.429 366.432 381.268 386.161",
    stroke: "#A2F8C5",
    strokeWidth: 7,
    strokeDasharray: "1.96 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.701 59.9335C415.06 80.9024 434.357 106.53 447.301 135.091C460.245 163.651 466.539 194.487 465.763 225.529C464.987 256.57 457.159 287.104 442.801 315.081C428.442 343.058 407.884 367.832 382.502 387.735",
    stroke: "#A2F8C5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMost);
export default __webpack_public_path__ + "static/media/right_most.45030e9ffaf906ec0349d5eb4b369915.svg";
export { ForwardRef as ReactComponent };